<template>
  <div>
    <component v-if="offer" :is="section" :options="{ editable, inline:false }" />
  </div>
</template>

<script>
import Heading from '../components/editor/Heading';
import CustomerAddress from '../components/editor/CustomerAddress';
import SeminarDetails from '../components/editor/SeminarDetails';
import ContactPerson from '../components/editor/ContactPerson';
import Introduction from '../components/editor/Introduction';
import Ekomi from '../components/editor/Ekomi';
import SalesStats from '../components/editor/SalesStats';
import PricingTable from '../components/editor/PricingTable';
import ServiceList from '../components/editor/ServiceList';
import AdditionalInfo from '../components/editor/AdditionalInfo';
import Equipment from '../components/editor/Equipment';
import SeminarContent from '../components/editor/SeminarContent';
import TrainerProfile from '../components/editor/TrainerProfile';
import AboutGfu from '../components/editor/AboutGfu';
import ServiceCards from '../components/editor/ServiceCards';
import { mapActions, mapGetters } from 'vuex';
import { setDocumentLanguage } from '../i18n';

export default {
  name: 'OfferPartial',
  data() {
    return {
      editable: true,
    }
  },
  computed: {
    ...mapGetters([
      'offer'
    ]),
    section() {
      const sections = this.$route.params.section.split('-');
      return sections.map(section => section.charAt(0).toUpperCase() + section.slice(1))
        .join('');
    }
  },
  components: {
    Heading,
    CustomerAddress,
    SeminarDetails,
    ContactPerson,
    Introduction,
    Ekomi,
    SalesStats,
    PricingTable,
    ServiceList,
    AdditionalInfo,
    Equipment,
    SeminarContent,
    TrainerProfile,
    AboutGfu,
    ServiceCards
  },
  methods: {
    ...mapActions(['fetchOffer']),
  },
  mounted() {
    this.fetchOffer(this.$route.params.offerHash);
  },
  watch: {
    offer: {
      immediate: true,
      handler(offer) {
        if (offer) setDocumentLanguage(offer.language || 'de');
      },
    },
  }
}
</script>
